import React from 'react'
import { FaEdit } from 'react-icons/fa';
import { Tooltip } from 'react-tooltip';
import { useDispatch } from 'react-redux';
import { groupDetailsRes, groupDetailsTodo } from '../../../LMS_Redux/LMS_Slices/Masters/GroupDetails';
import { useNavigate } from 'react-router-dom';
import { IoInformationCircleOutline } from "react-icons/io5";

export default function GroupListAction(props) {

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const { modalLoading, detailModal } = props;

    const userRole = JSON.parse(localStorage.getItem('user_data'));
    const role = userRole && userRole.vrole_name

    const group_details = () => {
        // console.log(props.data)
        // console.log(detailModal)
        modalLoading(true)
        detailModal(true)
        dispatch(groupDetailsTodo(props.data.id)).then(() => group_details_res())
    }

    const group_details_res = () => {
        if (groupDetailsRes && groupDetailsRes.success) {
            modalLoading(false)
        } else {
            modalLoading(false)
        }
    }

    const edit_list = () => {
        navigate('/add_group', { state: props.data })
    }

    return (
        <div>
            <IoInformationCircleOutline size={20} className='eye'
                onClick={() => group_details()}
                data-tooltip-id="detail"
                data-tooltip-content="Details!"
                data-tooltip-place="bottom"
            />
            {role != 'Instructor' &&
                <FaEdit size={20} className='edit ms-3'
                    onClick={() => edit_list()}
                    data-tooltip-id="edit"
                    data-tooltip-content="Edit Group!"
                    data-tooltip-place="bottom"
                />
            }

            <Tooltip id="detail" style={{ backgroundColor: "rgb(34, 98, 198)", zIndex: '9', lineHeight: 'normal' }} />
            <Tooltip id="edit" style={{ backgroundColor: "rgb(71, 187, 76)", zIndex: '9', lineHeight: 'normal' }} />
        </div>
    )
}
